import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AcedSelect, {
	SelectOption,
	SelectOptions,
} from "../../../components/essentials/input/select/AcedSelect";
import http from "../../../shared/utils/http";

const SelectSport = () => {
	const { t } = useTranslation();

	const [sports, setSports] = useState<SelectOptions>([]);

	useEffect(() => {
		http.get("/utils/sports").then((response) => {
			setSports(
				response.map(
					(sport: { name: string; value: string }) =>
					({
						value: sport.value,
						label: sport.name,
					} as SelectOption)
				)
			);
		});
	}, []);

	const { control } = useFormContext();
	return (
		<AcedSelect
			label={t("createJob.sportLabel")}
			options={[
				{
					value: "volleyball",
					label: t("sportData.sportsLabels.volleyball"),
				},
			]}
			control={control}
			name="sport"
			placeholder={t("createJob.placeholder.select")}
			defaultValue={{
				value: "volleyball",
				label: t("sportData.sportsLabels.volleyball"),
			}}
			rules={{ required: t("createJob.validation.required") }}
		></AcedSelect>
	);
};

export default SelectSport;
